export const MAX_FUNNEL_ADDITIONAL_LEVEL = 3;
export const FINAL_FUNNEL_FIXED_LEVEL = 3;
